module.exports = __webpack_public_path__ + "static/ar_performance-3d35fc0df39c7b5a6274a2709d4a9419.mp4";